  <!-- [class]="options?.htmlClass || ''"-->
  <div [class.floatLabelContainer]="true">
  <label *ngIf="options?.title"
    [attr.for]="'control' + layoutNode?._id"
    [class]="options?.labelHtmlClass"
    [style.display]="options?.notitle ? 'none' : ''"
    [innerHTML]="options?.title"></label>
  <select float-label [attr.data-placeholder]="options?.selectText"
    [formControl]="formControl"
    [attr.aria-describedby]="'control' + layoutNode?._id + 'Status'"
    [attr.readonly]="options?.readonly ? 'readonly' : null"
    [attr.required]="options?.required"
    [class]="options?.fieldHtmlClass"
    [attr.disabled]="controlDisabled ? true : null"
    [id]="'control' + layoutNode?._id"
    [name]="controlName"
    (change)="updateValue($event)">
    <option *ngFor="let selectItem of list"
       [value]="selectItem.value"
       [disabled]="selectItem && selectItem?.flag"
       [selected]="selectItem.value === controlValue">{{selectItem.name}}</option>
  </select>
  </div>
  <div class="hide-widget" *ngIf="hideWidget">
    <label class="label-class">{{options?.selectText}}</label>
    <div>NA</div>
  </div>


// WEBPACK FOOTER //
// ./src/app/customerservice/widgets/custom-select.widget.ts.CustomSelectWidgetComponent.html